import { Controller } from "stimulus"
import flatpickr from "flatpickr"
import { Portuguese } from "flatpickr/dist/l10n/pt.js"
import Rails from '@rails/ujs';

export default class extends Controller {
  static targets = [ "rangeFilter", "dateTimePicker", "toDate", "fromDate", "fromDateTime", "datePickerFeaturedListing" ]

  initialize() {
    if (this.element.nodeName !== 'FORM') console.error('This controller should be attached to a form.')
    this.onChange = this._handleChange.bind(this)
  }

  connect() {

    this.rangeFilterTargets.forEach((picker) => {
      let min_date = picker.getAttribute('data-min-date')
      let max_date = picker.getAttribute('data-max-date')
      let start_date = picker.getAttribute('data-start-date')
      let end_date = picker.getAttribute('data-end-date')

      flatpickr(picker, {
        locale: Portuguese,
        mode: "range",
        minDate: min_date || "1900-01",
        maxDate: max_date || "today",
        defaultDate: [start_date, end_date],
        onClose: function() {
          if(this.selectedDates.length == 2) {
            const event = new Event('rangeChange')
            picker.dispatchEvent(event)
          }
        }
      });

      picker.addEventListener('rangeChange', this.onChange);

    });

    this.dateTimePickerTargets.forEach((picker) => {
      flatpickr(picker, {
        locale: Portuguese,
        enableTime: true,
        noCalendar: false,
        time_24hr: true,
        allowInput: true
      });
    });

    this.fromDateTargets.forEach((picker) => {
      flatpickr(picker, {
        locale: Portuguese,
        allowInput: true,
        minDate: "today"
      });
    });

    this.toDateTargets.forEach((picker) => {
      flatpickr(picker, {
        locale: Portuguese,
        allowInput: true,
        minDate: "1900-01",
        maxDate: "today"
      });
    });


    this.fromDateTimeTargets.forEach((picker) => {
      flatpickr(picker, {
        locale: Portuguese,
        allowInput: true,
        minDate: "today",
        enableTime: true
      });
    });

    this.datePickerFeaturedListingTargets.forEach((picker) => {
      flatpickr(picker, {
        locale: Portuguese,
        minDate: "1900-01",
        defaultDate: 'today'
      });
    });
  }



  _handleChange() {
    if (typeof Rails === 'undefined') console.error('Rails is not present, we should import it now!')
    Rails.fire(this.element, 'submit')
  }

}
